import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './components/ValidationForm'

const root = ReactDOM.createRoot(document.getElementById('trust-validation-react-app'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
